import { useMutation, useQueryClient } from "react-query";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

export interface IUpdateResponseCodeRequest {
  id: number;
  errorCode: string;
  errorSource: string;
  errorCodeDesc: string;
  errorDetail: string;
  integrationCode: string;
  internalErrorCode: string;
  internalErrorCodeDesc: string;
  bankName: string;
}

async function updateResponseCode(
  params: IUpdateResponseCodeRequest
): Promise<any> {
  const { data } = await axiosInstance.post("/ResponseCode/UpdateResponseCode", params);
  return data;
}

export function useUpdateResponseCode() {
  const queryClient = useQueryClient();
  return useMutation((params: IUpdateResponseCodeRequest) => updateResponseCode(params), {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.responseCodes);
    },
  });
}
